import { useQuery } from "@apollo/client";
import { ReactElement } from "react";

import {
  GetAudienceContactFieldsQuery,
  GetSubscriberByAudienceContactQuery,
} from "~frontend/__generated__/graphql";
import { AsyncWrapper } from "~frontend/components/AsyncWrapper";
import { GET_SUBSCRIBER_BY_AUDIENCE_CONTACT } from "~frontend/graphql/shortcode";

import SubscriberDialog from "../shortcode/Subscribers/SubscriberDialog";
import { Shortcode } from "../shortcode/Subscribers/types";
import { SearchResultWithContact } from "./AudienceSubscriberTable";

export default function AudienceContactDialog({
  contact,
  onClose,
  shortcode,
  fieldDefinitions,
}: {
  contact: SearchResultWithContact;
  onClose: () => void;
  shortcode: Shortcode;
  fieldDefinitions: GetAudienceContactFieldsQuery["getAudienceContactFields"];
}): ReactElement {
  const { data, loading, error, refetch } =
    useQuery<GetSubscriberByAudienceContactQuery>(
      GET_SUBSCRIBER_BY_AUDIENCE_CONTACT,
      {
        variables: {
          input: {
            audienceContactId: contact.audienceContactId,
          },
        },
        skip: !contact,
      }
    );

  return (
    <AsyncWrapper data={data} loading={loading} errors={error}>
      {({ getSubscriberByAudienceContact: subscriber }) => (
        <SubscriberDialog
          subscriber={subscriber}
          updateSubscriber={() => refetch()}
          shortcode={shortcode}
          audienceContactFields={fieldDefinitions}
          onClose={onClose}
        />
      )}
    </AsyncWrapper>
  );
}
